import { onSubmitInfoBuying } from "api/interna-api";
import Button from "components/atoms/Button";
import Fielderror from "components/atoms/Fielderror";
import LoadingState from "components/atoms/LoadingState";
import Select2New from "components/atoms/Select2New";
import Textfield from "components/atoms/Textfield";
import { KEY_CAPTCHA } from "constants/env";
import { VALIDATION_PATTERN } from "constants/validation";
import { useSelector } from "hooks/useApp";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { requestFetchCities } from "redux/actions/general/cities";
import { requestFetchDistricts } from "redux/actions/general/district";
import { requestFetchWards } from "redux/actions/general/wards";
import {
  notEmptyObject,
} from "utils/utils-common";
import Fieldrow, { Fieldcell } from "../Fieldrow";
import "./index.scss";

type FormData = {
  name: string;
  email: string;
  phone: string;
  address: string;
  content: string;
  city_id: string;
  district_id: string;
  ward_id: string;
};

interface InfoBuyingFormProps {
  productId: number;
  onSubmitInfoBuyingForm: (result: boolean) => void;
}

const InfoBuyingForm: React.FC<InfoBuyingFormProps> = ({
  productId,
  onSubmitInfoBuyingForm,
}: InfoBuyingFormProps) => {
  const {
    handleSubmit,
    setValue,
    getValues,
    formState,
    errors,
    register,
  } = useForm<FormData>({
    mode: "onChange",
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      address: "",
      content: "",
      city_id: "",
      district_id: "",
      ward_id: "",
    },
  });

  useEffect(() => {
    register(
      {
        name: "ward_id",
      },
      { required: true },
    );
    register(
      {
        name: "city_id",
      },
      { required: true },
    );
    register(
      {
        name: "district_id",
      },
      { required: true },
    );
  }, [register]);

  const dispatch = useDispatch();

  let { cities, districts, wards } = useSelector(state => state.general);

  useEffect(() => {
    dispatch(requestFetchCities(1));
  }, [dispatch]);

  const [cityList, setCityList] = useState([]);

  const [districtList, setDistrictList] = useState([]);
  const [wardList, setWardList] = useState([]);

  useEffect(() => {
    const { data } = cities;
    if (data.length > 0) {
      setCityList(data.map(c => ({ value: c.id, label: c.name })));
    }
  }, [cities]);

  const onChangeCities = (cityId: number) => {
    setDistrictList([]);
    setValue("district_id", "", true);
    setWardList([]);
    setValue("ward_id", "", true);
    dispatch(requestFetchDistricts(cityId));
  };

  useEffect(() => {
    const { data } = districts;
    if (data.length > 0) {
      setDistrictList(
        data.map(c => ({ value: c.id, label: c.name, city_id: c.city_id })),
      );
    }
  }, [districts]);
  const onChangeDistricts = (districtId: number) => {
    setWardList([]);
    setValue("ward_id", "", true);
    dispatch(requestFetchWards(districtId));
  };

  const onChangeWards = (wardId: number) => { };

  useEffect(() => {
    const { data } = wards;
    if (data.length > 0) {
      setWardList(data.map(c => ({ value: c.id, label: c.name })));
    }
  }, [wards]);

  const [isLoading, setIsLoading] = useState(false);
  const touched = Object.values(formState.touched);
  const onSubmit = (data: any) => {
    setIsLoading(true);
    const { confirm_email, ...formData } = data;
    onSubmitInfoBuying({ ...formData, product_id: productId.toString() })
      .then(() => {
        onSubmitInfoBuyingForm(true);
        setIsLoading(false);
      })
      .catch(() => {
        onSubmitInfoBuyingForm(false);
        setIsLoading(false);
      });
  };

  const [needVerify, setNeedVerify] = useState(false);
  const [count, setCount] = useState<number>();

  useEffect(() => {
    if (notEmptyObject(errors)) {
      const countSave = Cookies.get("needVerify.InfoBuyingForm");
      setCount(countSave ? Number(countSave) + 1 : count ? count + 1 : 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  useEffect(() => {
    if (count !== undefined) {
      setNeedVerify(count === 3);
      Cookies.set("needVerify.InfoBuyingForm", count ? count.toString() : "1", {
        expires: 1, // 1 day
      });
    }
  }, [count]);

  useEffect(() => {
    const checkNeedVerifyCount = Cookies.get("needVerify.InfoBuyingForm");
    if (checkNeedVerifyCount) {
      setCount(Number(checkNeedVerifyCount));
      if (Number(checkNeedVerifyCount) >= 3) {
        setNeedVerify(true);
      }
    }
  }, []);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Fieldrow modifiers={["input"]}>
          <Fieldcell>
            <Textfield
              name="name"
              label="Họ Tên Khách Hàng"
              type="text"
              value={getValues().name}
              modifiers={
                (touched && formState.touched.name) || errors.name
                  ? errors.name
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
              refs={register({
                required: {
                  value: false,
                  message: "Bạn chưa nhập họ tên",
                },
                validate: value =>
                  value.length <= 0
                    ? "Bạn chưa nhập họ tên"
                    : true,
              })}
            />
            {errors.name && <Fielderror>{errors.name.message}</Fielderror>}
          </Fieldcell>
        </Fieldrow>
        <Fieldrow modifiers={["input"]}>
          <Fieldcell>
            <Textfield
              name="email"
              label="Email"
              type="email"
              value={getValues().email}
              modifiers={
                (touched && formState.touched.email) || errors.email
                  ? errors.email
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
              refs={register({
                required: {
                  value: true,
                  message: "Bạn chưa nhập - Email",
                },
                pattern: {
                  value: VALIDATION_PATTERN.common.email,
                  message: "Email không đúng định dạng",
                },
              })}
            />
            {errors.email && <Fielderror>{errors.email.message}</Fielderror>}
          </Fieldcell>
        </Fieldrow>
        <Fieldrow modifiers={["input"]}>
          <Fieldcell>
            <Textfield
              name="phone"
              label="Phone"
              type="text"
              value={getValues().phone}
              modifiers={
                (touched && formState.touched.phone) || errors.phone
                  ? errors.phone
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
              refs={register({
                required: {
                  value: true,
                  message: "Bạn chưa nhập - SĐT",
                },
                pattern: {
                  value: VALIDATION_PATTERN.common.phone,
                  message: "SĐT không đúng định dạng",
                },
              })}
            />
            {errors.phone && <Fielderror>{errors.phone.message}</Fielderror>}
          </Fieldcell>
        </Fieldrow>
        <Fieldrow modifiers={["input"]}>
          <Fieldcell>
            <Select2New
              options={cityList}
              name="city_id"
              initValue={getValues().city_id}
              setValue={(name: any, city_id: any) => {
                onChangeCities(city_id);
                setValue(name, city_id.toString(), true);
              }}
              placeholder={"Tỉnh/Thành Phố"}
              modifiers={
                (touched && formState.touched.city_id) || errors.city_id
                  ? errors.city_id || !getValues().city_id
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
            />
            {!getValues().city_id && formState.isSubmitted && (
              <Fielderror>Bạn chưa nhập Tỉnh/Thành Phố</Fielderror>
            )}
          </Fieldcell>
          <Fieldcell>
            <Select2New
              name="district_id"
              initValue={getValues().district_id}
              setValue={(name: any, district_id: any) => {
                onChangeDistricts(district_id);
                setValue(name, district_id.toString(), true);
              }}
              modifiers={
                (touched && formState.touched.district_id) || errors.district_id
                  ? errors.district_id
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
              placeholder={"Quận/Huyện"}
              options={districtList}
            />
            {!getValues().district_id && formState.isSubmitted && (
              <Fielderror>Bạn chưa nhập quận/ huyện</Fielderror>
            )}
          </Fieldcell>
          <Fieldcell>
            <Select2New
              name="ward_id"
              initValue={getValues().ward_id}
              setValue={(name: any, ward_id: any) => {
                onChangeWards(ward_id);
                setValue("ward_id", ward_id, true);
              }}
              modifiers={
                (touched && formState.touched.ward_id) || errors.ward_id
                  ? errors.ward_id
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
              placeholder={"Phường/ xã"}
              options={wardList}
            />
            {!getValues().ward_id && formState.isSubmitted && (
              <Fielderror>Bạn chưa nhập Phường/ xã</Fielderror>
            )}
          </Fieldcell>
        </Fieldrow>
        <Fieldrow modifiers={["input"]}>
          <Fieldcell>
            <Textfield
              name="address"
              label="Địa chỉ"
              type="text"
              value={getValues().address}
              modifiers={
                (touched && formState.touched.address) || errors.address
                  ? errors.address
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
              refs={register({
                required: {
                  value: true,
                  message: "Bạn chưa nhập - Địa chỉ",
                },
              })}
            />
            {errors.address && (
              <Fielderror>{errors.address.message}</Fielderror>
            )}
          </Fieldcell>
        </Fieldrow>
        <Fieldrow modifiers={["input"]}>
          <Fieldcell>
            <Textfield
              name="content"
              label="Nội dung"
              type="text"
              value={getValues().content}
              modifiers={
                (touched && formState.touched.content) || errors.content
                  ? errors.email
                    ? ["invalid"]
                    : ["valid"]
                  : []
              }
              refs={register({
                required: {
                  value: false,
                  message: "Bạn chưa nhập - Nội dung",
                },
                validate: value =>
                  value.length <= 0
                    ? "Bạn chưa nhập nội dung"
                    : true,
              })}
            />
            {errors.content && (
              <Fielderror>{errors.content.message}</Fielderror>
            )}
          </Fieldcell>
        </Fieldrow>
        {needVerify && KEY_CAPTCHA ? (
          <div className="form-recapcha">
            <form>
              <ReCAPTCHA
                sitekey={KEY_CAPTCHA}
                onChange={(value: any) => {
                  if (value) {
                    Cookies.remove("needVerify.InfoBuyingForm");
                    setNeedVerify(false);
                    setCount(undefined);
                  }
                }}
              />
            </form>
          </div>
        ) : (
          <Button
            modifiers={["rounded", "max-width"]}
            variant="primary"
            size="small"
          >
            TÔI MUỐN ĐƯỢC TƯ VẤN
          </Button>
        )}
      </form>
      {isLoading && <LoadingState />}
    </>
  );
};

InfoBuyingForm.defaultProps = {};

export default InfoBuyingForm;
